module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/top/banner_sp-4200138ecbb9d5ad5be3883f9520de05.png";